import { render } from "./PDFClienteInformacao.vue?vue&type=template&id=5862fbad&scoped=true"
import script from "./PDFClienteInformacao.vue?vue&type=script&lang=js"
export * from "./PDFClienteInformacao.vue?vue&type=script&lang=js"

import "./PDFClienteInformacao.vue?vue&type=style&index=0&id=5862fbad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5862fbad"]])

export default __exports__